export default {"src":"/_next/static/media/download.c523b9cd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};